$(document).ready(function () {
    $(".section_tax_banner .parallax-inner").parallaxContent({
        shift: -50,
        duration: 0
    });
});